import { useClientContext } from '../../contexts/ClientProvider';
import { Client } from '../../types/users';
import { showFullName } from '../../utils/commonFunctions';

const ClientDetails = ({ client }: { client: Client }) => {
  // integration of context hooks here
  const { setShowDetailsModal, setClient } = useClientContext();

  // rendering client details modal component here
  return (
    <div>
      <button
        onClick={() => {
          setShowDetailsModal(true);
          setClient(client);
        }}
        className='hover:opacity-70 active:scale-95 duration-300'
      >
        <p className='font-medium text-base-light-blue'>{`${showFullName(
          client.first_name,
          client.middle_name,
          client.last_name,
          true
        )} ${client.first_name ? '' : client.id}`}</p>
      </button>
    </div>
  );
};

export default ClientDetails;
